import React, { useContext } from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import { useRouter, useParams } from "../../hooks/useNavigation";
import styled, { useTheme } from "styled-components";

import FindYourRole from "../../../components/FindYourRole/FindYourRole";
import { useAppState } from "../../../contexts/ApplicationStateProvider";
import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import useFilters from "../../customHooks/useFilters";
import defaultSearchFields from "../../helpers/defaultSearchFields";
import normalizeFieldConfiguration from "../../helpers/normalizeFieldConfiguration";

const StyledSearchBox = styled.div`
  min-height: ${({ $minHeight }) => ($minHeight ? `${$minHeight}` : "100px")};
  z-index: 10;
  position: relative;
  background: ${({ $innerBackgroundColour }) =>
    $innerBackgroundColour || "transparent"};
  border-radius: ${({ $innerBorderRadius }) => $innerBorderRadius || "0px"};

  ${(props) =>
    props.$isOverlay
      ? `
    display: flex;
    justify-content: center;
    padding: 0 20px;
    position: relative;
    margin-top: -50px;
    height: auto;
    z-index: 999;
    `
      : ""}

  ${(props) => props.$dynamicStyles || ""}
`;

function SearchBox() {
  const { primaryColor } = useTheme();
  const router = useRouter();
  const searchParams = useParams();
  const { filtersStore } = useStores();
  const { filters } = filtersStore;

  const { isMobile } = useAppState();

  const {
    buttonText,
    buttonColour,
    buttonHoverColour,
    buttonTextColour,
    filters: filterFields = [],
    text,
    minHeight,
    resultsUrl,
    initialLocation,
    roleSelectPlaceholder,
    locationSelectPlaceholder,
    searchBoxComponent,
    innerBackgroundColour,
    isOverlay,
    innerBorderRadius,
    CSS,
  } = useContext(ComponentContext);

  const { handleSubmit } = useFilters();

  const fieldsConfiguration = normalizeFieldConfiguration(filterFields);

  const fields = !isEmpty(fieldsConfiguration)
    ? fieldsConfiguration
    : defaultSearchFields;

  const handleSearch = () => {
    // v5 format: filterFields might be { data: [...] } from API or already be an array
    // handleSubmit expects an array of flat objects
    const fieldsToPass = Array.isArray(filterFields)
      ? filterFields
      : filterFields?.data || [];
    handleSubmit(router, resultsUrl, filters, fieldsToPass, searchParams);
  };

  return (
    <StyledSearchBox
      className="d-flex align-items-center justify-content-center py-4"
      $minHeight={minHeight}
      $innerBackgroundColour={innerBackgroundColour}
      $isOverlay={isOverlay}
      $innerBorderRadius={innerBorderRadius}
      $dynamicStyles={CSS}
    >
      <div className="w-100">
        <FindYourRole
          buttonColor={buttonColour || primaryColor}
          buttonHoverColour={buttonHoverColour}
          buttonTextColour={buttonTextColour}
          buttonText={buttonText}
          fieldsConfiguration={fields}
          isInline={!isMobile}
          onSubmit={handleSearch}
          placeholders={{
            location: locationSelectPlaceholder,
            role: roleSelectPlaceholder,
          }}
          text={searchBoxComponent?.data.text || text}
          withoutBottomMargin
          initialValue={{
            location: {
              label: initialLocation,
              value: initialLocation,
            },
          }}
        />
      </div>
    </StyledSearchBox>
  );
}

export default observer(SearchBox);
